import React, { Fragment } from "react";
import MetaTags from "react-meta-tags";
import LayoutOne from "../layouts";
import HeroSliderOne from "../containers/hero-sliders/hero-slider-one";
import ServiceOne from "../containers/services/service-one";
import FeatureImageTextOne from "../containers/feature-image-texts/feature-image-text-one";
import ServiceTwo from "../containers/services/service-two";
import PricingTableOne from "../containers/pricing-tables/pricing-table-one";
import Faq from "../containers/contact-faqs/contact-faq-one";
import Work from "../containers/work-process/work-process-one";
import Reviews from "../containers/testimonials/testimonial-one";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const Home = () => {
  return (
    <Fragment>
      <MetaTags>
        <title>Adaptive Systems LLC | Home</title>
        <meta name="keywords" content="cable tv, cable companies, cable providers, cable service, comcast, xfinity" />
        <meta name="description" content="Find A Perfect HD TV Channels Service Provider In Your Area Today!"></meta>
      </MetaTags>
      <LayoutOne>
        <HeroSliderOne />
        <ServiceOne />
        <PricingTableOne />
        <Work />
        <FeatureImageTextOne />
        <ServiceTwo />
        <Reviews />
        <Faq />
        {/* <section className="zipSec" id="check-availability">
          <div className="container">
            <div class="row">
              <div class="col-lg-6 col-md-12 col-sm-12">
                <h3>Check Service Availability in Your Area</h3>
                <p class="text">Enter your ZIP code to view available internet, TV, and phone plans near you.</p>
              </div>
              <div class="col-lg-6 col-md-12 col-sm-12">
                <form method="post" action="">
                  <div className="form-group">
                    <input type="email" name="email" placeholder="ZIP Code" />
                    <button className="btn">Check Availability</button>
                  </div>
                  <p className="mt-2">Independent retailer. Availability may vary by location.</p>
                </form>
              </div>
            </div>
          </div>
        </section> */}  

        <div className="container pb--50">
          <h2>Disclaimer</h2>
          <p>The information provided by Adaptive Systems LLC is for general informational purposes only. We make no representations or warranties of any kind, express or implied, regarding the accuracy, reliability, or completeness of the content on our website or within our services. Use of our services is at your own risk. We are not responsible for any damages or losses resulting from the use of our services, including but not limited to service interruptions, data loss, or unauthorized access to your account. By using our services, you agree to comply with all applicable laws and the terms outlined in our Terms of Service and Privacy Policy.</p>
        </div>

      </LayoutOne>
    </Fragment>
  );
};

export default Home;
